module.exports = __webpack_public_path__ + "static/media/covid19Distance.3cf7f09f.png";